import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-alertas',
  templateUrl: './alertas.component.html',
  styleUrls: ['./alertas.component.scss']
})
export class AlertasComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  codeHtml: string;
  utils: any;

  constructor(private sanitizer:DomSanitizer) { 
    this.utils = window.utils;

    this.arrayComponent = [
      {
        id: 'alertaInformativa',
        titulo: 'Alerta Informativa',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-info" onClick="utils.blurredBackgroundModal()">Alerta Informativa</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-info">Alerta Informativa</button>
        <!-- Modal -->
        <div class="modal fade show alert-modal" id="modal-info" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
            <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Cerrar ventana" title="Cerrar ventana">x</button>
                    </div>
                    <div class="modal-body text-center modal-content-info">
                      <span class="govco-icon govco-icon-check-cn size-4x"></span>
                      <h2 class="headline-xl-govco">
                          Título de la Alerta
                      </h2>
                      <p>Texto de ejemplo:Muchas gracias por participar, recibirás una notificación al correo con tu participación.</p>
                    </div>
                </div>
            </div>
        </div>
      `,
      },
      {
        id: 'alertaExito',
        titulo: 'Alerta de Éxito',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        ` <!-- Botón que activa el modal -->
          <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-success" onClick="utils.blurredBackgroundModal()">Alerta de éxito</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        ` <!-- Botón que activa el modal -->
          <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-success">Alerta de éxito</button>
          <!-- Modal -->
          <div class="modal fade show alert-modal" id="modal-success" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
              <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                  <div class="modal-content">
                      <div class="modal-body text-center modal-content-success">
                          <span class="govco-icon govco-icon-check-cn size-4x"></span>
                        <h2 class="headline-xl-govco" id="modal-title-govco">Título de la Alerta</h2>
                        <p>Información de detalle al cierre de la acción.</p>            
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-round btn-high" data-dismiss="modal">ACEPTAR</button>
                      </div>
                  </div>
              </div>
          </div>
        `,
      },
      {
        id: 'alertaError',
        titulo: 'Alerta de Error',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-error" onClick="utils.blurredBackgroundModal()">Alerta de Error</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        `<!-- Botón que activa el modal -->
          <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-error">Alerta de Error</button>
          <!-- Modal -->
          <div class="modal fade show alert-modal" id="modal-error" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
              <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                  <div class="modal-content">
                      <div class="modal-body text-center modal-content-error">
                      <span class="govco-icon govco-icon-x-cn size-4x"></span>
                        <h2 class="headline-xl-govco" id="modal-title-govco">Título de la alerta</h2>
                        <p>Tu visualización no cumple con los criterios necesarios para su publicación ¿Quieres echarle un vistazo de nuevo a la postulación?</p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-round btn-middle" data-dismiss="modal">CANCELAR</button>
                        <button type="button" class="btn btn-round btn-high">ACEPTAR</button>
                      </div>
                  </div>
              </div>
          </div>
          `,
      },
      {
        id: 'alertaMantenimiento',
        titulo: 'Alerta de Mantenimiento',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-maintenance" onClick="utils.blurredBackgroundModal()">Alerta de Mantenimiento</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-maintenance">Alerta de Mantenimiento</button>
        <!-- Modal -->
        <div class="modal fade show alert-modal" id="modal-maintenance" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
            <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Cerrar ventana" title="Cerrar ventana">x</button>
                    </div>
                    <div class="modal-body text-center modal-content-maintenance">
                      <span class="govco-icon govco-icon-exclamation-cn size-4x"></span>
                      <h2 class="headline-xl-govco" id="modal-title-govco">En mantenimiento</h2>
                      <p>Esta página esta en mantenimiento en breve estaremos de vuelta.</p>
                      <p>Puedes escribirnos a soporteccc@mintic.gov.co. Llámanos gratis: 01 8000 910742 y en Bogotá: 3 90 79 51</p>
                    </div>
                </div>
            </div>
        </div>
      `,
      },
      {
        id: 'alertaAdvertencia',
        titulo: 'Alerta de Advertencia',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-warning" onClick="utils.blurredBackgroundModal()">Alerta de Advertencia</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-warning">Alerta de Advertencia</button>
        <!-- Modal -->
        <div class="modal fade show alert-modal" id="modal-warning" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
            <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-center modal-content-warning">
                    <span class="govco-icon govco-icon-sad-face-n size-4x"></span>
                      <h2 class="headline-xl-govco" id="modal-title-govco">Ha ocurrido un error</h2>
                      <p>Texto predeterminado.</p>
                      <p>Puedes escribirnos a soporteccc@mintic.gov.co. Llámanos gratis: 01 8000 910742 y en Bogotá: 3 90 79 51</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-round btn-high" data-dismiss="modal">REGRESAR</button>
                    </div>
                </div>
            </div>
        </div>
      `,
      },
      {
        id: 'alertaSalida',
        titulo: 'Alerta de Salida del Portal',
        subtitulo: '',
        claseContainer: 'col-10',
        componentFalseRender: //Este es fragmento se renderizara como componente HTML
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-exit" onClick="utils.blurredBackgroundModal()">Alerta de Salida del Portal</button>`,
        componentRender: //Este componente se renderizara en la sección de HTML Markup
        `<!-- Botón que activa el modal -->
          <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-exit">Alerta de Salida del Portal</button>
          <!-- Modal -->
          <div class="modal fade show alert-modal" id="modal-exit" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
              <div class="modal-dialog alert-govco modal-dialog-centered" role="document">
                  <div class="modal-content">
                      <div class="modal-body text-center modal-content-exit">
                      <span class="govco-icon govco-icon-exclamation-cn size-4x"></span>
                        <h2 class="headline-xl-govco" id="modal-title-govco">Estas saliendo de GOV.CO</h2>
                        <p>Con esta acción abrirás una nueva pestaña. ¡Te esperamos pronto!</p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-round btn-middle" data-dismiss="modal">CANCELAR</button>
                        <button type="button" class="btn btn-round btn-high" data-dismiss="modal">CONTINUAR</button>
                      </div>
                  </div>
              </div>
          </div>
          `,
      },
    ],
    this.infoComponent = {
      titulo: "Alertas tipo Modal",
      subtitulo: ""
    },
    this.codeHtml = `
    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" type="text/javascript"></script>`;
  }

  ngOnInit() {
  }

}

